import moment from "moment";
export const getDateTimeDiff = (a, b, unitOfTime) => {
    return Math.abs(moment(a)
        .diff(moment(b), unitOfTime));
};
